/**
 * Persisted NextGen player UX preferences (theater, fullscreen-on-play).
 * White-label safe — keys are ngp.* only.
 */

var THEATER_KEY = "ngp.theaterMode";
var FS_ON_PLAY_KEY = "ngp.fullscreenOnFirstPlay";

export function readTheaterMode() {
  try {
    var raw = localStorage.getItem(THEATER_KEY);
    if (raw === "1") return true;
    if (raw === "0") return false;
    return null;
  } catch (e) {
    return null;
  }
}

/**
 * Resolve theater from Admin TPG Player Setting (`player_theater_default`).
 *
 * Stale localStorage `ngp.theaterMode=0` previously overrode Admin "On" and
 * locked the shell at the hard-coded 1100px non-theater max-width — so TPG
 * Player Settings appeared to ignore size. Admin setting is authoritative for
 * initial layout; in-session toggle still updates Host React state.
 */
export function resolveTheaterMode(featureDefault) {
  return !!featureDefault;
}

export function persistTheaterMode(enabled) {
  try {
    localStorage.setItem(THEATER_KEY, enabled ? "1" : "0");
  } catch (e) {
    /* ignore */
  }
}

export function readFullscreenOnFirstPlay() {
  try {
    var raw = localStorage.getItem(FS_ON_PLAY_KEY);
    if (raw === "1") return true;
    if (raw === "0") return false;
    return null;
  } catch (e) {
    return null;
  }
}

/** Resolve fullscreen-on-first-play: localStorage, else admin default. */
export function resolveFullscreenOnFirstPlay(featureDefault) {
  var stored = readFullscreenOnFirstPlay();
  if (stored != null) return stored;
  return !!featureDefault;
}

export function persistFullscreenOnFirstPlay(enabled) {
  try {
    localStorage.setItem(FS_ON_PLAY_KEY, enabled ? "1" : "0");
  } catch (e) {
    /* ignore */
  }
}

/**
 * Map admin watermark_position → CSS modifier class.
 * @param {string} position
 * @returns {string}
 */
export function watermarkPositionClass(position) {
  var p = String(position || "bottom-right").toLowerCase().replace(/_/g, "-");
  switch (p) {
    case "top-left":
      return "ngp-watermark--top-left";
    case "top-right":
      return "ngp-watermark--top-right";
    case "bottom-left":
      return "ngp-watermark--bottom-left";
    case "center":
      return "ngp-watermark--center";
    case "bottom-right":
    default:
      return "ngp-watermark--bottom-right";
  }
}

export default {
  readTheaterMode: readTheaterMode,
  resolveTheaterMode: resolveTheaterMode,
  persistTheaterMode: persistTheaterMode,
  readFullscreenOnFirstPlay: readFullscreenOnFirstPlay,
  resolveFullscreenOnFirstPlay: resolveFullscreenOnFirstPlay,
  persistFullscreenOnFirstPlay: persistFullscreenOnFirstPlay,
  watermarkPositionClass: watermarkPositionClass,
};
